<template>
  <transition name="nav">
    <nav class="nav" v-if="navOpen">
      <div class="nav__content" v-if="device.winW > 768">
        <div class="nav__menu">
          <ul class="nav__menu-list">
            <router-link v-if="item['show_'+lang]===1"  v-for="(item, i) in nav.items" :to="item.path" tag="li"
              :key="'item'+i" class="nav__menu-item" @click.native="toggleNavState(false)">
              <a v-text="item.title" class="nav__menu-trigger" />
            </router-link>
          </ul>
        </div>
        <div class="nav__beverages">
          <ul class="nav__beverages-list">
            <router-link v-for="(item, j) in nav.beverages" :to="item.path"
              tag="li" :key="'beverage'+j" class="nav__beverages-item"
              :style="{backgroundColor:item.color}" @click.native="toggleNavState(false)">
              <a v-text="item.title" class="nav__beverages-trigger" />
            </router-link>
          </ul>
        </div>
      </div>
      <div class="nav__content" v-if="device.winW < 769">
        <div class="nav__scroll">
          <ul class="nav__list">
            <template v-for="(item, i) in mobNav">
              <li class="nav__menu-item" v-if="item.children.length && item['show_'+lang]===1" :to="item.path"
                :key="i">
                <span v-text="item.title" class="nav__menu-trigger" @click="subNav=mobNav[i].children"
                />
                <i class="nav__menu-arrow" />
              </li>
              <router-link class="nav__menu-item" v-else-if="item['show_'+lang]===1" tag="li" :to="item.path"
                :key="i">
                <a v-text="item.title" class="nav__menu-trigger" />
              </router-link>
            </template>
          </ul>
          <div class="nav__langs">
            <a :href="$store.getters.baseURL+'/lt'" :class="{'is-active':$store.getters.lang==='lt'}"
              class="nav__lang">LT</a>
            <a :href="$store.getters.baseURL+'/en'" :class="{'is-active':$store.getters.lang==='en'}"
              class="nav__lang">EN</a>
            <a :href="$store.getters.baseURL+'/ru'" :class="{'is-active':$store.getters.lang==='ru'}"
              class="nav__lang">RU</a>
          </div>
        </div>
      </div>
      <transition name="subnav">
        <div class="nav__content nav__content--subnav" v-if="subNav.length && device.winW < 769">
          <div class="nav__back" @click="subNav=[]" v-text="ui.nav_back_label"
          />
          <div class="nav__subnav">
            <div class="nav__scroll">
              <ul class="nav__menu">
                <router-link class="nav__menu-item" v-for="(item, j) in subNav"
                  tag="li" :to="item.path" :key="j">
                  <a v-text="item.title" class="nav__menu-trigger" />
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </transition>
    </nav>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppNav',
  data() {
    return {
      subNav: []
    }
  },
  computed: {
    ...mapGetters(['baseURL', 'nav', 'mobNav', 'device', 'navOpen', 'ui', 'lang'])
  },
  methods: {
    ...mapActions(['toggleNavState'])
  },
  mounted() {},
  watch: {
    $route() {
      this.subNav = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/AppNav.vue